package org.example.zone360.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import org.jetbrains.compose.web.dom.ElementBuilder
import org.jetbrains.compose.web.dom.TagElement
import org.jetbrains.compose.web.dom.Text

@Composable
fun CustomScrollBar() {
    val isFirefox = remember {
        js("!!window.navigator.userAgent.match(/Firefox/i)") as Boolean
    }

    TagElement(
        elementBuilder = ElementBuilder.createBuilder("style"),
        applyAttrs = null
    ) {
        Text(
            if (isFirefox) """
                html, body {
                    overflow-y: scroll;
                    scrollbar-gutter: stable;
                }
                * {
                    scrollbar-width: auto;
                    scrollbar-color: #FB6F2A #f1f1f1;
                }
            """.trimIndent()
            else """
                html, body {
                    overflow-y: scroll;
                    scrollbar-gutter: stable;
                }
                
                /* Defining ::-webkit-scrollbar forces WebKit to ALWAYS show scrollbar */
                *::-webkit-scrollbar {
                    width: 8px;
                    height: 8px;
                    background-color: #f1f1f1;
                }
                *::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 5px;
                }
                *::-webkit-scrollbar-thumb {
                    background: #FB6F2A;
                    border-radius: 5px;
                    min-height: 40px;
                }
                *::-webkit-scrollbar-thumb:hover {
                    background: #e05a1e;
                }
                *::-webkit-scrollbar-corner {
                    background: #f1f1f1;
                }
            """.trimIndent()
        )
    }
}